import React, { useEffect, useState } from "react";
import { Button, Icon, Pagination, Modal, Confirm } from "semantic-ui-react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import "./AdvocateList.css";
import {
  deleteAdvocate,
  reorderAdvocates,
} from "../../store/actions/athleteActions";
import AddAdvocate from "../layout/AddAdvocate";
import EditAdvocate from "../layout/EditAdvocate";
import { FaUserTie } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Link, Redirect } from "react-router-dom";

const AdvocatesList = (props) => {
  // defining States & Dispatch
  const [backUpObject, setBackUpObject] = useState([]);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const [updatedOrder, setUpdatedOrder] = useState(null);
  const [lastOrder, setLastOrder] = useState(null);
  const [data, setData] = useState([]);
  const [addAdvocateOpen, setAddAdvocateOpen] = useState(false);
  const [editAdvocateOpen, setEditAdvocateOpen] = useState(false);
  const [advocates, setAdvocates] = useState([]);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [deleteTitle, setDeleteTitle] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reOrder, setReOrder] = useState(false);
  const [emailsList, setEmails] = useState([]);
  const dispatch = useDispatch();

  // Open and Close Add Skill Modal
  const handleAddSkillOpen = () => {
    setAddAdvocateOpen(true);
  };
  const handleAddSkillClose = () => {
    setAddAdvocateOpen(false);
  };

  // Pagination

  const pageChange = (not, data) => {
    setActivePage(data.activePage);
  };

  // Getting Data From Props to save it in the State
  useEffect(() => {
    if (props.advocateData) {
      setData(props.advocateData);
    }
  }, [props.advocateData]);

  useEffect(() => {
    if (data.length > 0) {
      let storingObject = Object.keys(data);
      let object = [];
      let emails = [];
      if (storingObject.length > 0) {
        object = storingObject.map((key) => {
          emails.push(data[key].email);
          return {
            id: data[key].id,
            name: data[key].name,
            title: data[key].title,
            thumbnailUrl: data[key].thumbnailUrl,
            about: data[key].about,
            phone: data[key].phone,
            email: data[key].email,
            facebook: data[key].facebook,
            instagram: data[key].instagram,
            twitter: data[key].twitter,
            linkedin: data[key].linkedin,
            order: data[key].order,
            createdAt: data[key].createdAt,
          };
        });
      }
      setEmails(emails);
      object.sort((a, b) => a.order - b.order);
      setBackUpObject(object);
      setUpdatedOrder(object);
      setTotalPages(object.length / 6);
      const paginated =
        object && object.slice((activePage - 1) * 6, activePage * 6);
      setAdvocates(paginated);
      setLastOrder(object[object.length - 1].order);
    }
  }, [data, activePage]);
  // Delete Functionality (Currently it is deleting from firestore not from firebase)
  const handleDelete = () => {
    let fieldsArray = [...advocates];
    const storingArray = fieldsArray.filter(
      (field) => field.id !== deleteIndex
    );
    setAdvocates(storingArray);

    dispatch(deleteAdvocate(deleteIndex));
    setConfirmationPopup(false);
    setDeleteIndex(null);
  };

  const handleOnDragEnd = (result) => {
    setChangesMade(true);
    if (!result.destination) return;
    const items = Array.from(updatedOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setUpdatedOrder(items);
  };
  const handleSaveOrder = () => {
    const copyArray = JSON.parse(JSON.stringify(updatedOrder));
    copyArray.map((value, index) => (value.order = index + 1));
    dispatch(reorderAdvocates(copyArray));
    setReOrder(false);
    setChangesMade(false);
  };
  // Some Buttons
  const editButton = (id) => (
    <Button
      color="blue"
      name="RemovePlayerButton"
      onClick={() => {
        const advocate = advocates.filter((data) => data.id === id)[0];
        setEditData(advocate);
        setEditAdvocateOpen(true);
      }}
    >
      <Icon name="pencil" />
    </Button>
  );
  let card;
  let listDrag;
  if (!props.superAdmin) {
    return <Redirect to="/about" />;
  } else {
    if (advocates.length > 0) {
      card = advocates.map((advocate, index) => {
        return (
          <div className="card" key={advocate.id}>
            <div className="card-body">
              <img
                src={advocate.thumbnailUrl}
                alt={advocate.thumbnailUrl}
                className="user-picture shadow-sm rounded-circle"
              />
              <div className="user-content">
                <h5 className="text-capitalize user-name">{advocate.name}</h5>
                <p className=" text-capitalize text-muted small blockquote-footer">
                  {advocate.title}
                </p>
                <p className="small text-muted  pl0 line-break-4">
                  {advocate.about}
                </p>
                {advocate.phone && (
                  <p className="small text-muted  pl0 line-break-4 text-set">
                    <span>Cell :</span>
                    {`(${advocate.phone.slice(0, 3)}) ${advocate.phone.slice(
                      3,
                      6
                    )}-${advocate.phone.slice(6)}`}
                  </p>
                )}
                {advocate.email && (
                  <p className="small text-muted mb-0 pl0 line-break-4 text-set">
                    <span>Email :</span>
                    {advocate.email}
                  </p>
                )}

                <div className="with-social-logo">
                  {advocate.facebook && (
                    <a
                      href={advocate.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../images/facebook.svg").default}
                        alt="Facebook"
                      />
                    </a>
                  )}
                  {advocate.twitter && (
                    <a
                      href={advocate.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../images/twitter.svg").default}
                        alt="Twitter"
                      />
                    </a>
                  )}
                  {advocate.instagram && (
                    <a
                      href={advocate.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../images/instagram.svg").default}
                        alt="Instagram"
                      />
                    </a>
                  )}
                  {advocate.linkedin && (
                    <a
                      href={advocate.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../images/linkedIn.svg").default}
                        alt="Linked In"
                      />
                    </a>
                  )}
                </div>
                <div className="btn-foot">
                  {editButton(advocate.id)}
                  <Button
                    color="red"
                    name="RemovePlayerButton"
                    onClick={() => {
                      setDeleteIndex(advocate.id);
                      setDeleteTitle(advocate.name);
                      setConfirmationPopup(true);
                    }}
                  >
                    <Icon name="minus" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      });

      listDrag = updatedOrder.map((advocate, index) => {
        return (
          <Draggable key={advocate.id} draggableId={advocate.id} index={index}>
            {(provided) => (
              <li
                key={advocate.order}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <div className="card">
                  <div className="card-body">
                    <div className="one">
                      <FaUserTie size={20} color="#1678c2" />
                    </div>
                    <div className="two">
                      <h5>
                        {advocate.name}
                        <span>- {advocate.title}</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </li>
            )}
          </Draggable>
        );
      });
    } else {
      card = (
        <div className="single">
          {" "}
          <p className="not-found cu-center">There's No Data Right Now</p>
        </div>
      );
    }
  }

  return (
    <div className="HomeContainer">
      <div className="SkillsList">
        <h1>Advocate List</h1>
        <div
          className={
            reOrder
              ? "btn-data with-flex j-center small-mb"
              : "btn-data with-flex j-center"
          }
        >
          {reOrder && changesMade && (
            <Button
              icon
              labelPosition="left"
              color="green"
              name="saveButton"
              onClick={handleSaveOrder}
            >
              <Icon name="check" />
              Save
            </Button>
          )}
          {!reOrder && (
            <Button
              className="d-small-hidden"
              icon
              labelPosition="left"
              color="blue"
              name="AddRearrange"
              onClick={() => setReOrder(true)}
            >
              <Icon name="sort numeric up" />
              Rearrange
            </Button>
          )}
          {reOrder && (
            <Button
              className="d-small-hidden"
              icon
              labelPosition="left"
              color="red"
              name="AddRearrange"
              onClick={() => {
                if (changesMade) {
                  setConfirmPopup(true);
                } else {
                  setReOrder(false);
                }
              }}
            >
              <Icon name="close" />
              Close
            </Button>
          )}
          {!reOrder && (
            <>
              <Button
                icon
                labelPosition="left"
                color="teal"
                name="AddSkillButton"
                onClick={handleAddSkillOpen}
              >
                <Icon name="plus" />
                Add Advocate
              </Button>
              <Link to="/super-admin/slideshow">
                <Button
                  icon="image outline"
                  labelPosition="left"
                  color="grey"
                  name="saveButton"
                  content="Slideshow Photos"
                />
              </Link>
            </>
          )}
        </div>
        {reOrder ? (
          <>
            <div className="team-section single p-0">
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="characters">
                  {(provided) => (
                    <ul
                      className="drag-ul"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {advocates.length > 0 && listDrag}
                      {provided.placeholder}
                    </ul>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </>
        ) : (
          <div className="team-section small-p0">
            {advocates.length > 0 && card}
          </div>
        )}
        {advocates.length < 1 && <div className="team-section one">{card}</div>}
        {confirmationPopup && (
          <Modal className="delete-popup" open={confirmationPopup}>
            <Modal.Content>
              <p className="p1">Are you sure want to delete </p>
              <p className="p1">
                <b>{deleteTitle}?</b>
              </p>
              <p className="p2">This process cannot be undone.</p>
              <div className="delete-modal-footer">
                <Button
                  name="closeButton"
                  content="Cancel"
                  onClick={() => {
                    setConfirmationPopup(false);
                    setDeleteIndex(null);
                  }}
                />
                <Button
                  color="red"
                  name="saveButton"
                  content="Delete"
                  onClick={handleDelete}
                />
              </div>
            </Modal.Content>
          </Modal>
        )}
        {/* pagination and pages show */}
        {totalPages > 1 && !reOrder && (
          <div className="AthleteSearchDetail AthletePagination">
            <Pagination
              onPageChange={pageChange}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
      <Confirm
        open={confirmPopup}
        content="You have unsaved changes.  Are you sure you want to exit?"
        onCancel={() => {
          setConfirmPopup(false);
        }}
        onConfirm={() => {
          setConfirmPopup(false);
          setReOrder(false);
          setUpdatedOrder(backUpObject);
          setChangesMade(false);
        }}
      />
      <AddAdvocate
        open={addAdvocateOpen}
        onClose={handleAddSkillClose}
        lastOrder={lastOrder}
        emails={emailsList}
      />
      <EditAdvocate
        open={editAdvocateOpen}
        onClose={() => {
          setEditAdvocateOpen(false);
        }}
        editData={editData}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    advocateData: state.firestore.ordered.advocates,
    superAdmin: state.auth.superAdmin,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
  ])
)(AdvocatesList);
